/* Progressive enhancement only. Native product/cart scripts remain unchanged. */
(() => {
  if (window.carryDesignInitialized) return;
  window.carryDesignInitialized = true;
  let lastTrigger = null;
  const setBodyLock = () => document.body.classList.toggle('carry-dialog-open', !!document.querySelector('dialog.carry-dialog[open]'));
  const openDialog = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('dialog.carry-dialog[open]').forEach(item => item.close());
    lastTrigger = trigger || document.activeElement;
    dialog.showModal();
    setBodyLock();
    return true;
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-carry-open]');
    if (opener && openDialog(opener.dataset.carryOpen, opener)) { event.preventDefault(); return; }
    const closer = event.target.closest('[data-carry-close]');
    if (closer) closer.closest('dialog')?.close();
    const mobileLink = event.target.closest('.carry-mobile-nav a');
    if (mobileLink && !mobileLink.hasAttribute('data-carry-open')) mobileLink.closest('dialog').close();
    const carouselButton = event.target.closest('[data-carry-next],[data-carry-prev]');
    if (carouselButton) {
      const track = carouselButton.closest('[data-carry-carousel]').querySelector('[data-carry-track]');
      if (track) track.scrollBy({ left: track.clientWidth * (carouselButton.hasAttribute('data-carry-next') ? 1 : -1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    const dialog = event.target;
    if (dialog.matches('dialog.carry-dialog[open]')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  const recommendations = {
    everyday: { title: 'Your everyday companion', light: 'For a light commute, start around 10–20 liters. Look for accessible pockets and a comfortable fit. If you carry a laptop, compare its dimensions with the sleeve measurements.', full: 'For a fuller day, explore roughly 20–30 liters. Compare organization, laptop protection and room for lunch or an extra layer.' },
    outdoor: { title: 'Take the trail ahead', light: 'For a short outing, start around 15–25 liters. Plan space for water, layers and essentials, then check the specific pack’s intended use.', full: 'For a longer day outdoors, explore roughly 25–35 liters. Compare fit, load support and room for the supplies your route and weather require.' },
    travel: { title: 'Make room for a change of scenery', light: 'For a short, lightly packed trip, explore roughly 20–30 liters. Compare access, organization and the actual bag dimensions.', full: 'For a fuller weekend load, explore roughly 30–45 liters. Check the bag’s exact dimensions and your airline’s cabin limits before you travel.' }
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-carry-finder]');
    if (!form) return;
    event.preventDefault();
    const values = new FormData(form);
    const activity = values.get('activity');
    const result = recommendations[activity];
    if (!result) return;
    const box = form.querySelector('[data-carry-result]');
    box.querySelector('[data-carry-result-title]').textContent = result.title;
    box.querySelector('[data-carry-result-text]').textContent = result[values.get('load')] || result.light;
    box.querySelector('[data-carry-result-link]').href = form.dataset[activity];
    box.hidden = false;
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  });
  const init = (root = document) => {
    root.querySelectorAll('dialog.carry-dialog').forEach(dialog => {
      if (dialog.dataset.carryReady) return;
      dialog.dataset.carryReady = 'true';
      dialog.addEventListener('close', () => {
        setBodyLock();
        if (!document.querySelector('dialog.carry-dialog[open]')) lastTrigger?.focus?.();
      });
    });
    root.querySelectorAll('[data-carry-carousel]').forEach(carousel => {
      if (carousel.dataset.carryReady) return;
      carousel.dataset.carryReady = 'true';
      const track = carousel.querySelector('[data-carry-track]');
      const prev = carousel.querySelector('[data-carry-prev]');
      const next = carousel.querySelector('[data-carry-next]');
      const update = () => {
        if (!track) { prev.hidden = true; next.hidden = true; return; }
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      track?.addEventListener('scroll', update, { passive: true });
      if (track && 'ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
    const feedback = root.querySelector('[data-carry-contact-feedback]');
    if (feedback) openDialog('carry-contact');
    const newsletter = root.querySelector('[data-carry-feedback]');
    if (newsletter) newsletter.scrollIntoView({ block: 'center' });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', setBodyLock);
  document.addEventListener('pointerover', event => {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    const item = event.target.closest('.carry-nav-item');
    const details = item?.querySelector('.carry-dropdown');
    if (details) details.open = true;
  });
  document.addEventListener('pointerout', event => {
    const item = event.target.closest('.carry-nav-item');
    if (item && (!event.relatedTarget || !item.contains(event.relatedTarget))) {
      const details = item.querySelector('.carry-dropdown');
      if (details) details.open = false;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.carry-dropdown[open]').forEach(item => item.removeAttribute('open'));
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.carry-dropdown[open]').forEach(item => {
      if (!item.contains(event.target)) item.removeAttribute('open');
    });
  });
})();
